// client/src/services/supabaseAuthService.js
import { supabase } from './supabase';

const authService = {
  async getSession() {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) {
      return { data: null, error };
    }
    return { data: session, error: null };
  },

  onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange(callback);
  },

  async signUp({ email, password }) {
    // Construct base URL from origin and Public URL
    let redirectUrl = `${window.location.origin}${process.env.PUBLIC_URL}`;
    // Ensure it ends with a slash to match standard directory behavior and whitelist expectations
    if (!redirectUrl.endsWith('/')) {
      redirectUrl += '/';
    }

    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: redirectUrl,
      },
    });
    if (error) {
      return { data: null, error };
    }

    if (data.user) {
    }
    return { data: data.user, error: null };
  },

  async signInWithPassword({ email, password }) {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      return { data: null, error };
    }
    return { data: { user: data.user, session: data.session }, error: null };
  },

  async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) {
      return { data: null, error };
    }
    return { data: null, error: null };
  },

  async resetPasswordForEmail(email) {
    let redirectTo = `${window.location.origin}${process.env.PUBLIC_URL}`;
    if (!redirectTo.endsWith('/')) {
      redirectTo += '/';
    }
    // パスやクエリパラメータを付与するとSupabaseのAllow List制限に引っかかる可能性があるため
    // 単純なOrigin (またはBase URL) のみをRedirect URLとして使用する

    // update-passwordへの遷移はAuthContextのイベントリスナー(PASSWORD_RECOVERY)で制御する

    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo,
    });
    if (error) {
      return { data: null, error };
    }
    return { data, error: null };
  },

  async updateUser(attributes) {
    const { data, error } = await supabase.auth.updateUser(attributes);
    if (error) {
      return { data: null, error };
    }
    return { data: data.user, error: null };
  },
};

export default authService;
